// Sidebar.js
import React from 'react';
import Search from './Search';
import RecentArticles from './RecentArticles';
import RecentComments from './RecentComments';
import Categories from './Categories';

const SidebarBlog = ({ filterByCategory, recentArticles, onSearch }) => {
    return (
        <div className="sidebarblog">
            <Search onSearch={onSearch} />
            <RecentArticles articles={recentArticles} />
            <RecentComments recentArticles={recentArticles} />
            <Categories filterByCategory={filterByCategory}/>
        </div>
    );
};

export default SidebarBlog;
